import { Edit, Lock, Mail } from '@mui/icons-material';
import {
  Avatar,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { format } from 'date-fns';
import React, { FC, MouseEventHandler } from 'react';
import { useDialog } from '../../Dialog';
import { LockStatus } from '../useConcurrentialAccess';
import { useStyles } from './styles';
import { notifyByMail } from './utils';

interface LockedDialogProps {
  lockStatus: LockStatus;
  unlockLink?: string;
  onNavigateBack?: MouseEventHandler<HTMLButtonElement>;
  disableLockForV0?: boolean;
}

export const LockedDialog: FC<LockedDialogProps> = ({
  lockStatus,
  unlockLink,
  onNavigateBack,
  disableLockForV0,
}) => {
  const classes = useStyles();
  const { closeDialog } = useDialog();

  return (
    <>
      <DialogTitle>
        {disableLockForV0
          ? 'En cours de modification par un autre utilisateur'
          : 'Accès verrouillé'}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {disableLockForV0 ? (
          <Edit className={classes.icon} />
        ) : (
          <Lock className={classes.icon} />
        )}
        <DialogContentText>
          Une personne est déjà en train de modifier cette page,{' '}
          {disableLockForV0
            ? "vous risquez d'écraser ses modifications"
            : "vous ne pouvez pas l'éditer pour le moment. Revenez plus tard ou contactez-la"}
          .
        </DialogContentText>
      </DialogContent>
      {lockStatus?.lockedBy && (
        <DialogContent>
          <List disablePadding>
            <ListItem>
              <ListItemAvatar>
                <Avatar src={lockStatus.lockedBy.avatarUrl || undefined} />
              </ListItemAvatar>
              <ListItemText
                primary={lockStatus.lockedBy.name}
                secondary={
                  !!lockStatus.lockedAt &&
                  `Dernière activité le ${format(
                    new Date(lockStatus.lockedAt),
                    'dd/MM/yyyy à HH:mm',
                  )}`
                }
              />
              {lockStatus.lockedBy.email && unlockLink && !disableLockForV0 && (
                <ListItemSecondaryAction>
                  <Tooltip title="Notifier par mail">
                    <IconButton
                      onClick={() => notifyByMail(lockStatus, unlockLink)}
                    >
                      <Mail />
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          </List>
        </DialogContent>
      )}
      <DialogActions>
        {onNavigateBack && (
          <Button
            onClick={(e) => {
              closeDialog();
              onNavigateBack?.(e);
            }}
            color="primary"
          >
            Retour à la liste
          </Button>
        )}
        {disableLockForV0 ? (
          <Button onClick={closeDialog} color="primary" variant="contained">
            OK
          </Button>
        ) : (
          <Button
            onClick={() => location.reload()}
            color="primary"
            variant="contained"
          >
            Actualiser
          </Button>
        )}
      </DialogActions>
    </>
  );
};
